import { ListItem, Skeleton, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type PricingListItemProps = {
  label: ReactNode;
  value: ReactNode;
  loading?: boolean;
};

export function PricingListItem({ label, value, loading }: PricingListItemProps) {
  return (
    <ListItem>
      <Stack spacing={1} width="100%">
        {typeof label === 'string' ? (
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        ) : (
          label
        )}
        {loading ? <Skeleton /> : value}
      </Stack>
    </ListItem>
  );
}
